<template>
  <div>
    <div class="containerShaded">
        A PLACE IN HELL
        <div class="videoWrapper">
        <iframe id="myVid" width="100%" height="315" src="https://www.youtube.com/embed/q9toDg0roqY?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    <br>
    <br>
    <div class="containerShaded">
      BURN UP THE DEAD
      <div class="videoWrapper">
        <iframe id="myVid" width="100%" height="315" src="https://www.youtube.com/embed/t5uNnMKqZgw?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    <br>
    <br>
    <div class="containerShaded">
      PLEASURE OF HATE
      <div class="videoWrapper">
        <iframe id="myVid" width="100%" height="315" src="https://www.youtube.com/embed/c31Hzq0oibs?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    <br>
    <br>
    <div class="containerShaded">
      UNDER THE FLAG
      <div class="videoWrapper">
        <iframe id="myVid" width="100%" height="315" src="https://www.youtube.com/embed/rIMNAxvp_Sw?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    <br>
    <br>
    <div class="containerShaded">
      DEATH FROM ABOVE
      <div class="videoWrapper">
        <iframe id="myVid" width="100%" height="315" src="https://www.youtube.com/embed/HQOYhSCttfA?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
    <br>
    <br>
    <div class="containerShaded">
      SWALLOW MY HATE
      <div class="videoWrapper">
        <iframe id="myVid" width="100%" height="315" src="https://www.youtube.com/embed/3JIm4-8hF18?rel=0&amp;controls=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Video',
  // data () {
  //   return {
  //     msg: 'VIDEO'
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* #myVid{
  height: calc(100vh - 300px);
} */


.videoWrapper {
	position: relative;
	padding-bottom: 56.25%; /* 16:9 */
	padding-top: 25px;
	height: 0;
}
.videoWrapper iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

/* h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>



// WEBPACK FOOTER //
// src/components/Video.vue